<p-confirmDialog key="inbox" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="inboxconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div *ngIf="LoadingReport == true" class="LoadingDiv">
	<p-progressSpinner></p-progressSpinner>
</div>

<div *ngIf="LoadingReport == false">
	<div>
		<button class="btn btn-primary" (click)="onBack()">Back</button>
		<button class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete</button>
	</div>

	<div class="LightBorder">
		<label>Report:</label>
		<p>{{ JobDesc }}</p>

		<label class="SmallTopMargin">Subject:</label>
		<p>{{ Subject }}</p>

		<label class="SmallTopMargin">Body:</label>
		<p>{{ Body }}</p>

		<label class="SmallTopMargin">Report Generated:</label>
		<p>{{ c_dateDesc }}</p>
	</div>

	<div class="LightBorder TopMargin">
		<div>
			<button class="btn btn-primary" (click)="onExport()">Export</button>
		</div>

		<p-table
			#mydt
			[value]="lstTable"
			[loading]="LoadingReport"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th *ngFor="let col of lstCols">
						<p-columnFilter type="text" [field]="col" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th *ngFor="let col of lstCols" [pSortableColumn]="col">{{ col }}<p-sortIcon [field]="col"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Item>
				<tr [pSelectableRow]="Item">
					<td *ngFor="let col of lstCols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [innerHtml]="Item[col]">
						<!-- {{ Item[col] }} -->
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
